
var Globalize = require('globalize/dist/globalize-runtime');
require('globalize/dist/globalize-runtime/number');
require('globalize/dist/globalize-runtime/plural');
require('globalize/dist/globalize-runtime/message');
require('globalize/dist/globalize-runtime/date');
var validateParameterTypeNumber = Globalize._validateParameterTypeNumber;
var validateParameterPresence = Globalize._validateParameterPresence;
var numberRound = Globalize._numberRound;
var numberFormat = Globalize._numberFormat;
var numberFormatterFn = Globalize._numberFormatterFn;
var validateParameterTypeString = Globalize._validateParameterTypeString;
var numberParse = Globalize._numberParse;
var numberParserFn = Globalize._numberParserFn;
var pluralGeneratorFn = Globalize._pluralGeneratorFn;
var validateParameterTypeMessageVariables = Globalize._validateParameterTypeMessageVariables;
var messageFormat = Globalize._messageFormat;
var messageFormatterFn = Globalize._messageFormatterFn;
var validateParameterTypeDate = Globalize._validateParameterTypeDate;
var dateToPartsFormat = Globalize._dateToPartsFormat;
var dateToPartsFormatterFn = Globalize._dateToPartsFormatterFn;
var dateFormat = Globalize._dateFormat;
var dateFormatterFn = Globalize._dateFormatterFn;
var dateTokenizer = Globalize._dateTokenizer;
var dateParse = Globalize._dateParse;
var dateParserFn = Globalize._dateParserFn;

Globalize.a1457377354 = numberFormatterFn(["",,2,0,0,,,,,,"","00","-00","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a390881354 = numberFormatterFn(["",,4,0,0,,,,,,"","0000","-0000","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.a1432474826 = numberFormatterFn(["",,1,0,0,,,,,,"","0","-0","-","",numberRound(),"∞","NaN",{".":",",",":".","%":"%","+":"+","-":"-","E":"E","‰":"‰"},]);
Globalize.b1827356079 = numberParserFn([{",":".",".":",","%":"%","+":"+","-":"-","E":"E","‰":"‰"},,{"infinity":/^∞/,"nan":/^NaN/,"negativePrefix":/^-/,"negativeSuffix":/^/,"number":/^\d+/,"prefix":/^/,"suffix":/^/}]);
Globalize.a1486123774 = pluralGeneratorFn(function(n
) {
  var s = String(n).split('.'), v0 = !s[1];
  return (n == 1 && v0) ? 'one' : 'other';
});
Globalize.b1070432011 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisen: Urlaub, günstige Flüge, Tickets und Flugpreise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1130196643 = messageFormatterFn((function(  ) {
  return function(d) { return "Punkte eingelöst"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a207546822 = messageFormatterFn((function(  ) {
  return function(d) { return "Punkte werden nicht eingelöst"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a46349450 = messageFormatterFn((function(  ) {
  return function(d) { return "Dialogfeld schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a89330637 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiseziel"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a724981325 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b260000930 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2013975221 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1764173131 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1392060571 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1336819749 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Informationen zu " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2132246718 = messageFormatterFn((function(  ) {
  return function(d) { return "Website von " + d["0"] + " wird in einer neuen Registerkarte geöffnet; geh zurück zur ursprünglichen Registerkarte, um auf unserer Website fortzufahren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a520754077 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchergebnisse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a224500946 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein Reiseziel aus"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1220685228 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wähle ein Anreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a482035947 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle Daten für deine Reise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a948375057 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum muss nach dem Anreisedatum liegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a353573977 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum muss innerhalb von 28 Tagen nach dem Anreisedatum liegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b669346717 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wähle ein Abreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b158166191 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle die Anzahl der Reisenden aus"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1219312858 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib das Alter des reisenden Kindes an"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b623480918 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib das Alter der reisenden Kinder an."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1088765240 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten des Aufenthalts in der Unterkunft müssen innerhalb des Reisezeitraums liegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a405863597 = messageFormatterFn((function(  ) {
  return function(d) { return "Auswählen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1516975231 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1020934161 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b1709277459 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Reisende";}, one: function() { return number(d["1"]) + " Reisender";}, two: function() { return number(d["1"]) + " Reisende";}, few: function() { return number(d["1"]) + " Reisende";}, many: function() { return number(d["1"]) + " Reisende";}, other: function() { return number(d["1"]) + " Reisende";} }) + ", Haustiere"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b806390772 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a451313344 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " hinzugefügt. Bearbeite unten die Angaben zu den Gästen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1011332384 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer entfernt. Bearbeite unten die Angaben zu den Gästen in Zimmer " + d["0"] + "."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a774692412 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen, Gästeauswahl schließen, ohne Änderungen zu speichern. Oder bearbeite unten die Angaben zu den Gästen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b803827972 = messageFormatterFn((function(  ) {
  return function(d) { return "Übernehmen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a202632964 = messageFormatterFn((function(  ) {
  return function(d) { return "Änderungen speichern und Gästeauswahl schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a863848296 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer hinzufügen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a454885113 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1908926335 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " von " + d["1"] + " entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1612222017 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter von Kind " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b867234009 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b495742074 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer " + d["0"] + " von " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1888883512 = messageFormatterFn((function(  ) {
  return function(d) { return "Kind " + d["0"] + ", Alter auf " + d["1"] + " aktualisiert."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b195898530 = messageFormatterFn((function(  ) {
  return function(d) { return "Unter 1"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1586804880 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinder"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1742645977 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter 0-17)"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1068301530 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Erwachsene";}, one: function() { return number(d["0"]) + " Erwachsener";}, two: function() { return number(d["0"]) + " Erwachsene";}, few: function() { return number(d["0"]) + " Erwachsene";}, many: function() { return number(d["0"]) + " Erwachsene";}, other: function() { return number(d["0"]) + " Erwachsene";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1211812320 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Kinder";}, one: function() { return number(d["0"]) + " Kind";}, two: function() { return number(d["0"]) + " Kinder";}, few: function() { return number(d["0"]) + " Kinder";}, many: function() { return number(d["0"]) + " Kinder";}, other: function() { return number(d["0"]) + " Kinder";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a213695606 = messageFormatterFn((function(  ) {
  return function(d) { return "Erwachsene"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1273618958 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kinder in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a433015672 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Erwachsenen in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b507401266 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kinder in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2105319508 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Erwachsenen in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a721852544 = messageFormatterFn((function(  ) {
  return function(d) { return "Haustiere"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1965899292 = messageFormatterFn((function(  ) {
  return function(d) { return "Haustiere inbegriffen?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1444069488 = messageFormatterFn((function(  ) {
  return function(d) { return "Ja"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1739015234 = messageFormatterFn((function(  ) {
  return function(d) { return "Nein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1719318260 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wurde zu deinen Listen hinzugefügt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a538889978 = messageFormatterFn((function(  ) {
  return function(d) { return "Wird in einem neuen Fenster geöffnet"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b482622619 = messageFormatterFn((function(  ) {
  return function(d) { return "Gästebewertungen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b136311805 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a52046389 = messageFormatterFn((function(  ) {
  return function(d) { return "Verfügbarkeit prüfen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a836241760 = messageFormatterFn((function(  ) {
  return function(d) { return "Verfügbarkeit prüfen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1007407022 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche ändern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a539639023 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein späteres Anreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1594072395 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein früheres Anreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a4191440 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein späteres Abreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1058624812 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle ein früheres Abreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b341968934 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter Preis: " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1373389524 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Preis beträgt " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a318047993 = messageFormatterFn((function(  ) {
  return function(d) { return "Der neue Preis beträgt " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a524826887 = messageFormatterFn((function(  ) {
  return function(d) { return "Der Preis betrug " + d["0"] + ", jetzt beträgt er " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b844930432 = messageFormatterFn((function(  ) {
  return function(d) { return "pro Nacht"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a883695152 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1430313464 = messageFormatterFn((function(  ) {
  return function(d) { return "Weitere Details"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a229968146 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen und zu den Hoteldetails zurückkehren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1115480380 = messageFormatterFn((function(  ) {
  return function(d) { return "Das hat nicht geklappt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1692858506 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte führe eine neue Suche durch."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b481168017 = messageFormatterFn((function(  ) {
  return function(d) { return "Vielleicht gefällt dir auch"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a889057186 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1252349738 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren & filtern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1279548660 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1036120265 = messageFormatterFn((function(  ) {
  return function(d) { return "Löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2036950990 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicke auf Übernehmen oder navigiere zurück, um die Filter zu schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1187882576 = messageFormatterFn((function(  ) {
  return function(d) { return "Mindestpreis"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a308724962 = messageFormatterFn((function(  ) {
  return function(d) { return "Höchstpreis"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1242311847 = messageFormatterFn((function(  ) {
  return function(d) { return "Sternebewertung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2037115352 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren nach"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b810208393 = messageFormatterFn((function(  ) {
  return function(d) { return "Filtern nach"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a284440119 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück zur Hotelsuche"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b829740371 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir durchsuchen Tausende von Unterkünften"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b105578216 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir durchsuchen Tausende von Reisepaketen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a367857436 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Filter";}, one: function() { return number(d["0"]) + " Filter";}, two: function() { return number(d["0"]) + " Filter";}, few: function() { return number(d["0"]) + " Filter";}, many: function() { return number(d["0"]) + " Filter";}, other: function() { return number(d["0"]) + " Filter";} }) + " angewandt"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a187824028 = messageFormatterFn((function(  ) {
  return function(d) { return "Sortieren & filtern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a179327664 = messageFormatterFn((function(  ) {
  return function(d) { return "Filter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2007582915 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf Karte anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1821377190 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Ergebnisse werden geladen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1606864901 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Ergebnisse wurden aktualisiert"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a290150731 = messageFormatterFn((function(  ) {
  return function(d) { return "Fehler beim Abrufen der Ergebnisse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1624593911 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Ergebnisse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1641199733 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotels suchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b521469764 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1869931921 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche es mit diesen Daten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1929994197 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr Daten anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1892173081 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger Daten anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1370997290 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel-Suchergebnisse für " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a495679863 = messageFormatterFn((function(  ) {
  return function(d) { return "Ungültige Hotel-Suchergebnisse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a361126539 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1107900753 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider konnten wir keine Ergebnisse finden.  Versuche es mit einer anderen Suchanfrage."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1115553145 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählter Filter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1231486505 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Filter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1909128023 = messageFormatterFn((function(  ) {
  return function(d) { return "Reiseziel nicht angegeben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b357853387 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "–" + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b482216107 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle Filter entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1447354644 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Gäste";}, one: function() { return number(d["0"]) + " Gast";}, two: function() { return number(d["0"]) + " Gäste";}, few: function() { return number(d["0"]) + " Gäste";}, many: function() { return number(d["0"]) + " Gäste";}, other: function() { return number(d["0"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1071930028 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider liegt bei uns gerade ein Problem vor"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a19300807 = messageFormatterFn((function(  ) {
  return function(d) { return "Erneut versuchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1482599569 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " in deinen Listen speichern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a285800711 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " aus deinen Listen entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a196728081 = messageFormatterFn((function(  ) {
  return function(d) { return "Details deines nächsten Aufenthalts"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b698486202 = messageFormatterFn((function(  ) {
  return function(d) { return "In diesem Gebiet suchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1143827668 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist gerade etwas schiefgegangen. Bitte wiederhole deine Suche."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1837354565 = messageFormatterFn((function(  ) {
  return function(d) { return "Karte schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b91812099 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Unterkünfte";}, one: function() { return number(d["0"]) + " Unterkunft";}, two: function() { return number(d["0"]) + " Unterkünfte";}, few: function() { return number(d["0"]) + " Unterkünfte";}, many: function() { return number(d["0"]) + " Unterkünfte";}, other: function() { return number(d["0"]) + " Unterkünfte";} }) + "\nab " + d["1"]; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b185208806 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Unterkünfte";}, one: function() { return number(d["0"]) + " Unterkunft";}, two: function() { return number(d["0"]) + " Unterkünfte";}, few: function() { return number(d["0"]) + " Unterkünfte";}, many: function() { return number(d["0"]) + " Unterkünfte";}, other: function() { return number(d["0"]) + " Unterkünfte";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1134917069 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1961825120 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1547832654 = messageFormatterFn((function(  ) {
  return function(d) { return "Das tut uns leid, bei uns ist gerade etwas schiefgegangen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a996249086 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Element"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1893976958 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriges Element"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2103750053 = messageFormatterFn((function(  ) {
  return function(d) { return "Zum Buchungsabschluss"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1642574534 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Deine Reise (" + plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a687727441 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Deine Reise (" + plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Aufenthalte";}, one: function() { return number(d["0"]) + " Aufenthalt";}, two: function() { return number(d["0"]) + " Aufenthalte";}, few: function() { return number(d["0"]) + " Aufenthalte";}, many: function() { return number(d["0"]) + " Aufenthalte";}, other: function() { return number(d["0"]) + " Aufenthalte";} }) + ")"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b1575043445 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Zimmer auswählen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1270063320 = messageFormatterFn((function(  ) {
  return function(d) { return "Nicht mehr verfügbar"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1735498188 = messageFormatterFn((function(  ) {
  return function(d) { return "Eine oder mehrere Unterkünfte dieser Reise sind nicht mehr verfügbar. Möchtest du dennoch zum Buchungsabschluss gehen?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1221358099 = messageFormatterFn((function(  ) {
  return function(d) { return "pro Zimmer"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1076630299 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Gäste";}, one: function() { return number(d["0"]) + " Gast";}, two: function() { return number(d["0"]) + " Gäste";}, few: function() { return number(d["0"]) + " Gäste";}, many: function() { return number(d["0"]) + " Gäste";}, other: function() { return number(d["0"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b1157462721 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b329389108 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + "/Nacht"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b190877076 = messageFormatterFn((function(  ) {
  return function(d) { return "Zimmer ändern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b399700856 = messageFormatterFn((function(  ) {
  return function(d) { return "Code in die Zwischenablage kopiert."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b652570655 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider liegt bei uns gerade ein Problem vor."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1200272990 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte wiederhole deine Suche."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1202094520 = messageFormatterFn((function(  ) {
  return function(d) { return "Erneut versuchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b735570613 = messageFormatterFn((function(  ) {
  return function(d) { return "Mietwagenabholung und -rückgabe"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b336726484 = messageFormatterFn((function(  ) {
  return function(d) { return "Abholzeit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1959996608 = messageFormatterFn((function(  ) {
  return function(d) { return "Rückgabezeit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a539467103 = messageFormatterFn((function(  ) {
  return function(d) { return "Mietwagen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b800765108 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Rückgabezeit muss mindestens zwei Stunden nach der Abholzeit liegen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2086383736 = messageFormatterFn((function(  ) {
  return function(d) { return "00:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2086473109 = messageFormatterFn((function(  ) {
  return function(d) { return "00:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2087307257 = messageFormatterFn((function(  ) {
  return function(d) { return "01:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2087396630 = messageFormatterFn((function(  ) {
  return function(d) { return "01:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2088230778 = messageFormatterFn((function(  ) {
  return function(d) { return "02:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2088320151 = messageFormatterFn((function(  ) {
  return function(d) { return "02:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2089154299 = messageFormatterFn((function(  ) {
  return function(d) { return "03:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2089243672 = messageFormatterFn((function(  ) {
  return function(d) { return "03:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2090077820 = messageFormatterFn((function(  ) {
  return function(d) { return "04:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2090167193 = messageFormatterFn((function(  ) {
  return function(d) { return "04:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2091001341 = messageFormatterFn((function(  ) {
  return function(d) { return "05:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2091090714 = messageFormatterFn((function(  ) {
  return function(d) { return "05:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2091924862 = messageFormatterFn((function(  ) {
  return function(d) { return "06:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2092014235 = messageFormatterFn((function(  ) {
  return function(d) { return "06:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2092848383 = messageFormatterFn((function(  ) {
  return function(d) { return "07:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2092937756 = messageFormatterFn((function(  ) {
  return function(d) { return "07:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2093771904 = messageFormatterFn((function(  ) {
  return function(d) { return "08:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2093861277 = messageFormatterFn((function(  ) {
  return function(d) { return "08:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2094695425 = messageFormatterFn((function(  ) {
  return function(d) { return "09:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2094784798 = messageFormatterFn((function(  ) {
  return function(d) { return "09:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2115012887 = messageFormatterFn((function(  ) {
  return function(d) { return "10:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2115102260 = messageFormatterFn((function(  ) {
  return function(d) { return "10:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2115936408 = messageFormatterFn((function(  ) {
  return function(d) { return "11:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2116025781 = messageFormatterFn((function(  ) {
  return function(d) { return "11:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2116859929 = messageFormatterFn((function(  ) {
  return function(d) { return "12:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2116949302 = messageFormatterFn((function(  ) {
  return function(d) { return "12:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2117783450 = messageFormatterFn((function(  ) {
  return function(d) { return "13:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2117872823 = messageFormatterFn((function(  ) {
  return function(d) { return "13:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2118706971 = messageFormatterFn((function(  ) {
  return function(d) { return "14:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2118796344 = messageFormatterFn((function(  ) {
  return function(d) { return "14:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2119630492 = messageFormatterFn((function(  ) {
  return function(d) { return "15.00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2119719865 = messageFormatterFn((function(  ) {
  return function(d) { return "15:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2120554013 = messageFormatterFn((function(  ) {
  return function(d) { return "16:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2120643386 = messageFormatterFn((function(  ) {
  return function(d) { return "16:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2121477534 = messageFormatterFn((function(  ) {
  return function(d) { return "17:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2121566907 = messageFormatterFn((function(  ) {
  return function(d) { return "17:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2122401055 = messageFormatterFn((function(  ) {
  return function(d) { return "18:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2122490428 = messageFormatterFn((function(  ) {
  return function(d) { return "18:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2123324576 = messageFormatterFn((function(  ) {
  return function(d) { return "19:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2123413949 = messageFormatterFn((function(  ) {
  return function(d) { return "19:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2143642038 = messageFormatterFn((function(  ) {
  return function(d) { return "20:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2143731411 = messageFormatterFn((function(  ) {
  return function(d) { return "20:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2144565559 = messageFormatterFn((function(  ) {
  return function(d) { return "21:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2144654932 = messageFormatterFn((function(  ) {
  return function(d) { return "21:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2145489080 = messageFormatterFn((function(  ) {
  return function(d) { return "22:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2145578453 = messageFormatterFn((function(  ) {
  return function(d) { return "22:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2146412601 = messageFormatterFn((function(  ) {
  return function(d) { return "23:00 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2146501974 = messageFormatterFn((function(  ) {
  return function(d) { return "23:30 Uhr"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1969180103 = messageFormatterFn((function(  ) {
  return function(d) { return "Nur Direktflüge"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1084188684 = messageFormatterFn((function(  ) {
  return function(d) { return "Bevorzugte Beförderungsklasse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b86966796 = messageFormatterFn((function(  ) {
  return function(d) { return "Economy"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1689524883 = messageFormatterFn((function(  ) {
  return function(d) { return "Premium Economy"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1807016532 = messageFormatterFn((function(  ) {
  return function(d) { return "Business Class"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b961356844 = messageFormatterFn((function(  ) {
  return function(d) { return "First Class"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a462045355 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisende"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b204833865 = messageFormatterFn((function(  ) {
  return function(d) { return "Für jedes Kleinkind auf dem Schoß muss mindestens eine Person im Alter von mindestens 6 Jahren mitreisen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1393898738 = messageFormatterFn((function(  ) {
  return function(d) { return "Kleinkinder"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a965255035 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter 2–17 J.)"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1435285015 = messageFormatterFn((function(  ) {
  return function(d) { return "(Alter unter 2 J.)"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1434453157 = messageFormatterFn((function(  ) {
  return function(d) { return "Alter von Kleinkind " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1402597409 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kleinkinder in Zimmer " + d["0"] + " verringern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b720628995 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzahl der Kleinkinder in Zimmer " + d["0"] + " erhöhen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1667504527 = messageFormatterFn((function(  ) {
  return function(d) { return "Kinder unter 2 Jahren müssen auf einem eigenen Sitzplatz oder auf dem Schoß sitzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b582622729 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf dem Schoß"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1429744117 = messageFormatterFn((function(  ) {
  return function(d) { return "Auf einem Sitzplatz"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1596378100 = messageFormatterFn((function(  ) {
  return function(d) { return "Altersbeschränkungen der Fluglinie"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a508021888 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreiseort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1060564616 = messageFormatterFn((function(  ) {
  return function(d) { return "Hinreise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1099466948 = messageFormatterFn((function(  ) {
  return function(d) { return "Rückreise"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a671815266 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle einen Abflughafen aus"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a238379460 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich benötige nur während eines Teils meiner Reise eine Unterkunft"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1745065341 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns etwas schiefgegangen. Bitte versuche es noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a920936177 = messageFormatterFn((function(  ) {
  return function(d) { return "Wähle mindestens 1 weitere Unterkunft zum Vergleichen aus."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1603841714 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "/" + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Unterkünften";}, one: function() { return number(d["1"]) + " Unterkunft";}, two: function() { return number(d["1"]) + " Unterkünften";}, few: function() { return number(d["1"]) + " Unterkünften";}, many: function() { return number(d["1"]) + " Unterkünften";}, other: function() { return number(d["1"]) + " Unterkünften";} }) + " ausgewählt"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1053518506 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return d["0"] + "von " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Unterkünften";}, one: function() { return number(d["1"]) + " Unterkunft";}, two: function() { return number(d["1"]) + " Unterkünften";}, few: function() { return number(d["1"]) + " Unterkünften";}, many: function() { return number(d["1"]) + " Unterkünften";}, other: function() { return number(d["1"]) + " Unterkünften";} }) + " zum Vergleich ausgewählt"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a888937272 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergleichen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2136269284 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Unterkünfte vergleichen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a414803710 = messageFormatterFn((function(  ) {
  return function(d) { return "Vergleichen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1223818786 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Unterkünfte vergleichen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1215308592 = messageFormatterFn((function(  ) {
  return function(d) { return "Anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b78487732 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicken, um die Unterkunft anzuzeigen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1387617553 = messageFormatterFn((function(  ) {
  return function(d) { return "Entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1639345011 = messageFormatterFn((function(  ) {
  return function(d) { return "Klicken, um die Unterkunft aus dem Vergleich zu entfernen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a36721666 = messageFormatterFn((function(  ) {
  return function(d) { return "Schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b77570362 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1573233748 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwerfen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a171086350 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b467218864 = messageFormatterFn((function(  ) {
  return function(d) { return "Entfernen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b778285465 = messageFormatterFn((function(  ) {
  return function(d) { return "ausgewählt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1482559866 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladevorgang läuft"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a26962711 = messageFormatterFn((function(  ) {
  return function(d) { return "Löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1153905553 = messageFormatterFn((function(  ) {
  return function(d) { return "Wird in einem neuen Fenster geöffnet"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a125492907 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1861478216 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1119284692 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a203124729 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1246315666 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Wählen Sie nun ein Abreisedatum aus."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1691025215 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Tippen Sie nun auf Fertig, um die Daten zu speichern und den Kalender zu schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a875290147 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", aktuelles Anreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2106217182 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", aktuelles Abreisedatum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1574745036 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", deaktivierte Zelle"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2120339697 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", aktueller Monat"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a808988692 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell wird Folgendes angezeigt: " + d["0"] + " und " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1479553624 = messageFormatterFn((function(  ) {
  return function(d) { return "Kalender geöffnet. Wählen Sie aus den Tabellen unten einen Reisezeitraum aus."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a652695350 = messageFormatterFn((function(  ) {
  return function(d) { return "Abbrechen, Kalender schließen ohne Änderungen zu speichern. Oder wählen Sie aus den Tabellen unten einen Reisezeitraum aus."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a228363098 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählte Daten entfernen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1868641743 = messageFormatterFn((function(  ) {
  return function(d) { return "Änderungen speichern und Kalender schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1233857142 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Nächte";}, 1: function() { return "Eine Nacht";}, two: function() { return number(d["0"]) + " Nächte";}, few: function() { return number(d["0"]) + " Nächte";}, many: function() { return number(d["0"]) + " Nächte";}, other: function() { return number(d["0"]) + " Nächte";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1951622362 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreise am"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b852283797 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreise am"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1296877812 = messageFormatterFn((function(  ) {
  return function(d) { return "Daten zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1799514677 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b81609295 = messageFormatterFn((function(  ) {
  return function(d) { return "Suchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a916988583 = messageFormatterFn((function(  ) {
  return function(d) { return "Bearbeiten Sie das Anreisedatum in den Tabellen unten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a17607224 = messageFormatterFn((function(  ) {
  return function(d) { return "Bearbeiten Sie das Abreisedatum in den Tabellen unten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1956139321 = messageFormatterFn((function(  ) {
  return function(d) { return "ausgewählt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1294089300 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. Schließe den Kalender oder fahre fort, um das ausgewählte Datum zu ändern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1632895652 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " bis " + d["1"] + " ausgewählt. Schließe den Kalender oder fahre fort, um die ausgewählten Daten zu ändern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b607196766 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ausgewählt. " + d["1"] + ". Schließe den Kalender oder fahre fort, um das ausgewählte Datum zu ändern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a887263018 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " bis " + d["1"] + " ausgewählt. " + d["2"] + ". Schließe den Kalender oder fahre fort, um die ausgewählten Daten zu ändern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1186082307 = messageFormatterFn((function(  ) {
  return function(d) { return "Anreisedatum auswählen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1183132022 = messageFormatterFn((function(  ) {
  return function(d) { return "Abreisedatum auswählen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1376781979 = messageFormatterFn((function(  ) {
  return function(d) { return "leer"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2017964029 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriger Monat"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a857466855 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächster Monat"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1677246920 = messageFormatterFn((function(  ) {
  return function(d) { return "Zur Schaltfläche " + d["0"] + " springen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2042236832 = messageFormatterFn((function(  ) {
  return function(d) { return "Vom " + d["0"] + " bis " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1569634653 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten wurden entfernt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1053034704 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Es gibt " + plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Ergebnisse";}, 1: function() { return "ein Ergebnis";}, two: function() { return number(d["0"]) + " Ergebnisse";}, few: function() { return number(d["0"]) + " Ergebnisse";}, many: function() { return number(d["0"]) + " Ergebnisse";}, other: function() { return number(d["0"]) + " Ergebnisse";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a346240455 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Zu deiner Eingabe " + d["0"] + " " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, one: function() { return "ist " + number(d["1"]) + " Ergebnis";}, two: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, few: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, many: function() { return "sind " + number(d["1"]) + " Ergebnisse";}, other: function() { return "sind " + number(d["1"]) + " Ergebnisse";} }) + " verfügbar. Navigiere mithilfe der Pfeiltasten oder einer Wischbewegung durch die Liste."; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b772987347 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche nach " + d["0"] + " ist geöffnet, bitte gib einen Suchbegriff ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a275548898 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Auswahl: " + d["0"] + "."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b82916673 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Menü wurde geschlossen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a976370053 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet und zeigt derzeit " + plural(d["1"], 0, pluralFuncs["de-DE"], { 0: function() { return "keine Vorschläge";}, 1: function() { return "einen Vorschlag";}, two: function() { return number(d["1"]) + " Vorschläge";}, few: function() { return number(d["1"]) + " Vorschläge";}, many: function() { return number(d["1"]) + " Vorschläge";}, other: function() { return number(d["1"]) + " Vorschläge";} }) + " für " + d["2"] + " an. Bitte navigiere nach unten zur Liste mit den Vorschlägen."; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a344807954 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet und zeigt " + plural(d["1"], 0, pluralFuncs["de-DE"], { 0: function() { return "keine Vorschläge";}, 1: function() { return "einen Vorschlag";}, two: function() { return number(d["1"]) + " Vorschläge";}, few: function() { return number(d["1"]) + " Vorschläge";}, many: function() { return number(d["1"]) + " Vorschläge";}, other: function() { return number(d["1"]) + " Vorschläge";} }) + " an. Gib einen Suchbegriff ein oder navigiere zur Liste unten."; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b733924686 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Die Suche für " + d["0"] + " ist geöffnet. Derzeitige Auswahl " + d["1"] + ". Es " + plural(d["1"], 0, pluralFuncs["de-DE"], { 0: function() { return "werden keine Vorschläge";}, 1: function() { return "wird ein Vorschlag";}, two: function() { return "werden " + number(d["1"]) + " Vorschläge";}, few: function() { return "werden " + number(d["1"]) + " Vorschläge";}, many: function() { return "werden " + number(d["1"]) + " Vorschläge";}, other: function() { return "werden " + number(d["1"]) + " Vorschläge";} }) + " für " + d["3"] + " angezeigt. Bitte navigiere nach unten zur Liste mit den Vorschlägen."; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b793062412 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b114942763 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle löschen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1935086018 = messageFormatterFn((function(  ) {
  return function(d) { return "Ausgewählt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b298933621 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " wurde gelöscht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a714366382 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle ausgewählten Optionen wurden gelöscht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1758567683 = messageFormatterFn((function(  ) {
  return function(d) { return "Sie haben etwas in das Textfeld eingetippt. Bitte suchen oder wählen Sie aus den Vorschlägen unten eine Kategorie aus."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a42467044 = messageFormatterFn((function(  ) {
  return function(d) { return "Suche nach „" + d["0"] + "“"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1797301853 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Ergebnisse für „" + d["0"] + "“"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a605347513 = messageFormatterFn((function(  ) {
  return function(d) { return "Flughafen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b268296670 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1437262328 = messageFormatterFn((function(  ) {
  return function(d) { return "Sehenswürdigkeit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1839639839 = messageFormatterFn((function(  ) {
  return function(d) { return "Nahe bei"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b674993634 = messageFormatterFn((function(  ) {
  return function(d) { return "Versuche doch einmal „" + d["0"] + "“"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b682295801 = messageFormatterFn((function(  ) {
  return function(d) { return "Region/Stadt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b834874363 = messageFormatterFn((function(  ) {
  return function(d) { return "Flughafen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b877082557 = messageFormatterFn((function(  ) {
  return function(d) { return "Attraktion"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a637466222 = messageFormatterFn((function(  ) {
  return function(d) { return "Hotel"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b451089170 = messageFormatterFn((function(  ) {
  return function(d) { return "Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1569004904 = messageFormatterFn((function(  ) {
  return function(d) { return "Bahnhof"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b699382409 = messageFormatterFn((function(  ) {
  return function(d) { return "Metrostation"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b663722533 = messageFormatterFn((function(  ) {
  return function(d) { return "Orte in deiner Nähe"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a399871374 = messageFormatterFn((function(  ) {
  return function(d) { return "Zuletzt gesucht"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1476994100 = messageFormatterFn((function(  ) {
  return function(d) { return "Danach suchten andere Nutzer"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1917363519 = messageFormatterFn((function(  ) {
  return function(d) { return "Angesagte Reiseziele entdecken"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1945100653 = messageFormatterFn((function(  ) {
  return function(d) { return "Beliebte Reiseziele"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a807734793 = messageFormatterFn((function(  ) {
  return function(d) { return "Angesagte Reiseziele"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1941921909 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktueller Standort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b178607864 = messageFormatterFn((function(  ) {
  return function(d) { return "Standortfreigabe deaktiviert"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1315871304 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider können wir deinen Standort nicht ermitteln. Aktiviere bitte die standortbezogenen Dienste auf deinem Gerät oder gib einen Ort ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1548822180 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Zimmer";}, one: function() { return number(d["0"]) + " Zimmer";}, two: function() { return number(d["0"]) + " Zimmer";}, few: function() { return number(d["0"]) + " Zimmer";}, many: function() { return number(d["0"]) + " Zimmer";}, other: function() { return number(d["0"]) + " Zimmer";} }) + ", " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Gäste";}, one: function() { return number(d["1"]) + " Gast";}, two: function() { return number(d["1"]) + " Gäste";}, few: function() { return number(d["1"]) + " Gäste";}, many: function() { return number(d["1"]) + " Gäste";}, other: function() { return number(d["1"]) + " Gäste";} }); }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.a1135486506 = messageFormatterFn((function(  ) {
  return function(d) { return "Im Feld " + d["0"] + " steht jetzt " + d["1"] + ". Im Feld " + d["2"] + " steht jetzt " + d["3"] + "."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1786458343 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " und " + d["1"] + " vertauschen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1440634 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b312901505 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort verbergen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1380575864 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell wird Folgendes angezeigt: " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b722267363 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " von " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b544810311 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " von " + d["1"] + ". " + d["2"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2013363574 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Bild öffnen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1352441998 = messageFormatterFn((function(  ) {
  return function(d) { return "Voriges Bild öffnen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a980417704 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle " + d["0"] + " Bilder öffnen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1651605965 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return plural(d["0"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["0"]) + " Bilder";}, 1: function() { return "Ein Bild";}, two: function() { return number(d["0"]) + " Bilder";}, few: function() { return number(d["0"]) + " Bilder";}, many: function() { return number(d["0"]) + " Bilder";}, other: function() { return number(d["0"]) + " Bilder";} }) + " für " + d["1"] + " öffnen"; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b1497033462 = messageFormatterFn((function(  ) {
  return function(d) { return "Abgeschlossen:"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1366243768 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuell:"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b650359578 = messageFormatterFn((function(  ) {
  return function(d) { return "Schritt " + d["0"] + " von " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1232506102 = messageFormatterFn((function(  ) {
  return function(d) { return "Schritt " + d["0"] + " von " + d["1"] + ":"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a721772471 = messageFormatterFn((function(  ) {
  return function(d) { return "Bild " + d["0"] + " von " + d["1"] + ". " + d["2"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1833358860 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächstes Bild"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a357866736 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriges Bild"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1615993662 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", auf Vollbild vergrößern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1531926934 = messageFormatterFn((function(  ) {
  return function(d) { return "Miniaturansicht " + d["0"] + ", auf Vollbild vergrößern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a5976916 = messageFormatterFn((function(  ) {
  return function(d) { return "Aktuelle Seite"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1459109980 = messageFormatterFn((function(  ) {
  return function(d) { return "Mehr Breadcrumbs anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1421288864 = messageFormatterFn((function(  ) {
  return function(d) { return "Weniger Breadcrumbs anzeigen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1440823869 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Prozent, Ladevorgang läuft."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a388714622 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladevorgang läuft"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b603839374 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + ", " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b723462199 = messageFormatterFn((function(  ) {
  return function(d) { return "Ein Fehler ist aufgetreten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1860751341 = messageFormatterFn((function(  ) {
  return function(d) { return "Sieh dir dieses Video auf YouTube an oder aktiviere JavaScript, falls es in deinem Browser deaktiviert ist."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a561661099 = messageFormatterFn((function(  ) {
  return function(d) { return "Video abspielen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b519160027 = messageFormatterFn((function(  ) {
  return function(d) { return "Video anhalten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a501525501 = messageFormatterFn((function(  ) {
  return function(d) { return "Video lädt"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2040071309 = messageFormatterFn((function(  ) {
  return function(d) { return "360-Grad-Bild"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1718545453 = messageFormatterFn((function(  ) {
  return function(d) { return "Dies ist eine 360-Grad-Aufnahme. Verwende die Steuerungstaste und die Pfeiltasten oder die Befehlstaste und die Pfeiltasten, um in ihr zu navigieren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b952874368 = messageFormatterFn((function(  ) {
  return function(d) { return "Momentan wird folgendes Bild angezeigt: " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b720427489 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach links verschoben. Position: " + d["0"] + " Grad"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a286798810 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach rechts verschoben. Position: " + d["0"] + " Grad"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1157067507 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach oben verschoben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b939724806 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach unten verschoben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1604965493 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast den obersten Bildrand erreicht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a836135393 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast den untersten Bildrand erreicht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a179599413 = messageFormatterFn((function(  ) {
  return function(d) { return "Alle Zeilen auswählen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1741456788 = messageFormatterFn((function(  ) {
  return function(d) { return "Auswahl aller Zeilen aufheben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1941712476 = messageFormatterFn((function(  ) {
  return function(d) { return "Spalte in absteigender Reihenfolge sortieren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2062867710 = messageFormatterFn((function(  ) {
  return function(d) { return "Spalte in aufsteigender Reihenfolge sortieren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b860963246 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Einträge der Spalte werden jetzt in absteigender Reihenfolge angezeigt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1281248746 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Einträge der Spalte werden jetzt in aufsteigender Reihenfolge angezeigt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1391419726 = messageFormatterFn((function(  ) {
  return function(d) { return "Zeile " + d["0"] + " erweitern."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1275324785 = messageFormatterFn((function( number, plural, pluralFuncs ) {
  return function(d) { return "Anzeige von " + d["0"] + " von " + plural(d["1"], 0, pluralFuncs["de-DE"], { zero: function() { return number(d["1"]) + " Elementen";}, one: function() { return number(d["1"]) + " Element";}, two: function() { return number(d["1"]) + " Elementen";}, few: function() { return number(d["1"]) + " Elementen";}, many: function() { return number(d["1"]) + " Elementen";}, other: function() { return number(d["1"]) + " Elementen";} }) + "."; }
})(messageFormat.number, messageFormat.plural, {"de-DE": Globalize("de-DE").pluralGenerator()}), Globalize("de-DE").pluralGenerator({}));
Globalize.b1683281825 = messageFormatterFn((function(  ) {
  return function(d) { return "Derzeit werden die Monat " + d["0"] + " " + d["1"] + " und " + d["2"] + " " + d["3"] + " angezeigt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a602654727 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Anreisedatum wurde gelöscht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1094208176 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Abreisedatum wurde gelöscht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b621189521 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Daten wurden gelöscht."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1727982643 = messageFormatterFn((function(  ) {
  return function(d) { return "Nächster Monat"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1272784115 = messageFormatterFn((function(  ) {
  return function(d) { return "Vorheriger Monat"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1383719406 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist als Anreisedatum ausgewählt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a969535625 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist als Abreisedatum ausgewählt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1091381550 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist kein gültiges Anreisedatum."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b105912617 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " ist kein gültiges Abreisedatum."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b407623430 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine Verfügbarkeit am " + d["0"] + "."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b673227989 = messageFormatterFn((function(  ) {
  return function(d) { return "Heute"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1200697876 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " von " + d["1"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2034735318 = messageFormatterFn((function(  ) {
  return function(d) { return "Bei " + d["0"] + " anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a768757731 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen zurück! Anmelden mit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b450593769 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen zurück! Melde dich an und spare dank Preisen für Mitglieder zusätzlich 10% oder mehr bei Tausenden Unterkünften."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1512052483 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b30839062 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1679010393 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto gewünscht?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1415208117 = messageFormatterFn((function(  ) {
  return function(d) { return "Die Anmeldung erfolgt ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2037257928 = messageFormatterFn((function(  ) {
  return function(d) { return "Über Facebook anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1752473797 = messageFormatterFn((function(  ) {
  return function(d) { return "Über Google anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1009973141 = messageFormatterFn((function(  ) {
  return function(d) { return "Angemeldet bleiben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1612545234 = messageFormatterFn((function(  ) {
  return function(d) { return "Angemeldet bleiben (verwendet Cookies)"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a184006628 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a184366042 = messageFormatterFn((function(  ) {
  return function(d) { return "Registrieren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1014908170 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder <a href=\"" + d["0"] + "\">über Facebook anmelden</a>"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a149359872 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort vergessen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1156789485 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine E-Mail-Adresse an"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b900346647 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine gültige E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a932675802 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib dein Passwort ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1043891872 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte versuche es erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1546800548 = messageFormatterFn((function(  ) {
  return function(d) { return "Ups! Irgendwas ist schiefgegangen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b772868478 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte korrigiere den Fehler, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1396515545 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte korrigiere die Fehler, um fortzufahren."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a424908689 = messageFormatterFn((function(  ) {
  return function(d) { return "Mit der E-Mail-Adresse anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b807808990 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder mit der E-Mail-Adresse anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b948988135 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1485560186 = messageFormatterFn((function(  ) {
  return function(d) { return "oder"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2008797512 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort vergessen?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1157579381 = messageFormatterFn((function(  ) {
  return function(d) { return "Noch nicht registriert?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1824278081 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1271349520 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich mich anmelde, stimme ich den <a href=\"" + d["0"] + "\" target=\"_blank\">allgemeinen Geschäftsbedingungen von " + d["1"] + "<span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a> zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b482536070 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich mich bei meinem " + d["0"] + "-Konto anmelde, stimme ich den <a href=\"" + d["1"] + "\" target=\"_blank\">Nutzungsbedingungen<span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a> und der <a href=\"" + d["3"] + "\" target=\"_blank\">Datenschutzrichtlinie<span class=\"is-visually-hidden\">Wird in einem neuen Fenster geöffnet</span></a> von " + d["2"] + " sowie den <a href=\"" + d["4"] + "\" target=\"_blank\">Geschäftsbedingungen<span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a> von " + d["5"] + " zu. "; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a630246442 = messageFormatterFn((function(  ) {
  return function(d) { return "Jetzt für <a href=\"" + d["0"] + "\" target=\"_blank\">" + d["1"] + " anmelden. <span class=\"is-visually-hidden\">Wird in einem neuen Fenster geöffnet.</span></a> Indem ich mich anmelde, akzeptiere ich alle <a href=\"" + d["3"] + "\" target=\"_blank\">allgemeinen Geschäftsbedingungen. <span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a>"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1417721018 = messageFormatterFn((function(  ) {
  return function(d) { return "Es gelten Nutzungs- und Geschäftsbedingungen, die Links findest du am Ende der Seite"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b521543476 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast Post!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1616963065 = messageFormatterFn((function(  ) {
  return function(d) { return "Setze dein Passwort mit dem Link zurück, den wir an " + d["0"] + " gesendet haben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1391317382 = messageFormatterFn((function(  ) {
  return function(d) { return "Link erneut senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1905886502 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns gerade etwas schiefgegangen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a139014111 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte versuche es noch einmal."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a286685242 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a6130054 = messageFormatterFn((function(  ) {
  return function(d) { return "Es wurde ein neuer Link gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b851074528 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto bei " + d["0"] + " erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1276152359 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen über"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b243405561 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto mit deiner E-Mail-Adresse erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1589996308 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder Konto mit deiner E-Mail-Adresse erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1467225308 = messageFormatterFn((function(  ) {
  return function(d) { return "Vor- und Nachname"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a80815650 = messageFormatterFn((function(  ) {
  return function(d) { return "Nach- und Vorname"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b135181881 = messageFormatterFn((function(  ) {
  return function(d) { return "8–30 Zeichen ohne Leerzeichen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b854440137 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b804649914 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast bereits ein Konto?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1740123706 = messageFormatterFn((function(  ) {
  return function(d) { return "Indem ich ein Konto erstelle, stimme ich den <a href=\"" + d["1"] + "\" target=\"_blank\">Nutzungsbedingungen von " + d["0"] + "<span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a>, der <a href=\"" + d["2"] + "\" target=\"_blank\">Datenschutzrichtlinie<span class=\"is-visually-hidden\">Wird in einem neuen Fenster geöffnet</span></a> und den <a href=\"" + d["3"] + "\" target=\"_blank\">" + d["4"] + " allgemeinen Geschäftsbedingungen <span class=\"is-visually-hidden\">Werden in einem neuen Fenster geöffnet</span></a> zu."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1240814113 = messageFormatterFn((function(  ) {
  return function(d) { return "Sendet mir Newsletter mit Reiseschnäppchen, Sonderangeboten und weiteren Informationen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2094806571 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir per E-Mail einen Link geschickt, um deine Kontoerstellung abzuschließen. "; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b272595306 = messageFormatterFn((function(  ) {
  return function(d) { return "Um deine Kontoerstellung abzuschließen, klicke auf den Link in der E-Mail an " + d["0"] + "."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a977513983 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1498232923 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib deine E-Mail-Adresse ein, damit wir dir einen Link zum Zurücksetzen deines Passworts senden können."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1058835887 = messageFormatterFn((function(  ) {
  return function(d) { return "Link zum Zurücksetzen zusenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1408058783 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder Buchung als Gast abschließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a394775751 = messageFormatterFn((function(  ) {
  return function(d) { return "Neues Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2107705240 = messageFormatterFn((function(  ) {
  return function(d) { return "Neues Passwort erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1401373843 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Adresse: " + d["0"]; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1631823223 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort speichern"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b872352389 = messageFormatterFn((function(  ) {
  return function(d) { return "Dieser Link ist leider nicht mehr gültig"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1657741360 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte fordere einen neuen Link an, um dein Passwort zurückzusetzen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1519294320 = messageFormatterFn((function(  ) {
  return function(d) { return "Neuen Link zum Zurücksetzen zusenden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b6853401 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück zur Anmeldung"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1826165574 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir per E-Mail einen neuen Link zum Zurücksetzen des Passworts geschickt."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1679683697 = messageFormatterFn((function(  ) {
  return function(d) { return "Wie lautet deine E-Mail-Adresse?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a63890324 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib eine E-Mail-Adresse an, damit die Reiseanbieter oder " + d["0"] + " dich erreichen können. Wir senden dir einen Sicherheitscode zur Bestätigung deiner Identität."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b795329689 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast dein " + d["0"] + "-Konto mit einer Telefonnummer erstellt. Bitte gib eine E-Mail-Adresse an, damit wir dich anmelden können. Wir senden dir einen Sicherheitscode zur Bestätigung deiner Identität."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1663579738 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicherheitscode senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a881692660 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicherheitscode eingeben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b109503476 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib den Sicherheitscode ein, den wir an " + d["0"] + " gesendet haben."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a555403459 = messageFormatterFn((function(  ) {
  return function(d) { return "Sicherheitscode"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b70011201 = messageFormatterFn((function(  ) {
  return function(d) { return "Senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a602884213 = messageFormatterFn((function(  ) {
  return function(d) { return "Keine E-Mail erhalten?"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1274123055 = messageFormatterFn((function(  ) {
  return function(d) { return "Neuen Code senden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1713062004 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir einen neuen Sicherheitscode per E-Mail gesendet."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b230152431 = messageFormatterFn((function(  ) {
  return function(d) { return "Gültigen Sicherheitscode eingeben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b751232266 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast die maximale Anzahl von Versuchen für das erneute Senden des Sicherheitscodes überschritten. Bitte versuche es nach 24 Stunden erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a285787060 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast den Sicherheitscode zu oft falsch eingegeben. Bitte versuche es nach 24 Stunden erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1853125965 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte gib den richtigen Sicherheitscode ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1068778807 = messageFormatterFn((function(  ) {
  return function(d) { return "Die von dir eingegebene E-Mail-Adresse wurde bereits verwendet, um ein " + d["0"] + "-Konto über " + d["1"] + " zu erstellen. Versuche, dich über das " + d["1"] + "-Konto anzumelden, das mit dieser E-Mail-Adresse verknüpft ist."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a351964834 = messageFormatterFn((function(  ) {
  return function(d) { return "Setze bitte aus Sicherheitsgründen dein Passwort zurück, bevor du dich anmeldest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1434823052 = messageFormatterFn((function(  ) {
  return function(d) { return "Wenn du ein Konto bei " + d["0"] + " hast, senden wir dir per E-Mail einen Link, über den du dein Passwort zurücksetzen kannst."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a246282143 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen zurück, " + d["0"] + "!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1444612795 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein neues Passwort wurde gespeichert."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1220971343 = messageFormatterFn((function(  ) {
  return function(d) { return "Weiter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b906008961 = messageFormatterFn((function(  ) {
  return function(d) { return "Herzlich willkommen, " + d["0"] + "!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b15156445 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns gerade etwas schiefgegangen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b314420052 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte korrigiere die " + d["0"] + " Fehler, um fortzufahren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1300555037 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast eine unbekannte E-Mail-Adresse oder ein falsches Passwort eingegeben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b645866085 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir konnten leider keine Verbindung zu " + d["0"] + " herstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1162552486 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Link zum Zurücksetzen ist leider abgelaufen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1973544512 = messageFormatterFn((function(  ) {
  return function(d) { return "Bitte fordere einen neuen Link an"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1414498630 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine Sitzung ist leider abgelaufen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b581545710 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib deinen Vor- und Nachnamen ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b737147046 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib deinen Nach- und Vornamen ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1969504296 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib den Namen nur mit Buchstaben ein"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1050296 = messageFormatterFn((function(  ) {
  return function(d) { return "Diese E-Mail-Adresse ist bereits mit einem " + d["0"] + "-Konto verbunden  "; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a943677372 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort darf keine Leerzeichen enthalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1704483101 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort darf nicht deine E-Mail-Adresse sein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1034433273 = messageFormatterFn((function(  ) {
  return function(d) { return "Dieses Passwort ist leicht zu erraten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a252584110 = messageFormatterFn((function(  ) {
  return function(d) { return "Diese E-Mail-Adresse wird bereits verwendet"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1861909921 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib dein Passwort ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a994650491 = messageFormatterFn((function(  ) {
  return function(d) { return "Dieses Passwort ist falsch."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2023296439 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Passwort muss mindestens " + d["0"] + " Zeichen haben"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1614754807 = messageFormatterFn((function(  ) {
  return function(d) { return "Das Passwort muss zwischen " + d["0"] + " und " + d["1"] + " Zeichen enthalten."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b980779015 = messageFormatterFn((function(  ) {
  return function(d) { return "Diese E-Mail-Adresse wurde bereits verwendet, um ein " + d["0"] + "-Konto über " + d["1"] + " zu erstellen. Bitte verwende eine andere E-Mail-Adresse oder melde dich mit dem " + d["1"] + "-Konto an, das mit dieser E-Mail-Adresse verknüpft ist."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1437087635 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider können wir deine Apple ID für die Anmeldung nicht verwenden. Bald soll es möglich sein hierfür Apple IDs zu verwenden, die Telefonnummern sind. Bitte verwende in der Zwischenzeit eine andere Anmeldemethode."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1742883337 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir können dieses Konto nicht finden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a794872552 = messageFormatterFn((function(  ) {
  return function(d) { return "Gib eine E-Mail-Adresse ein."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a138850233 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmeldung schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a651636527 = messageFormatterFn((function(  ) {
  return function(d) { return "Kontoerstellung schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b58730220 = messageFormatterFn((function(  ) {
  return function(d) { return "Zurück zur vorherigen Seite"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1076072307 = messageFormatterFn((function(  ) {
  return function(d) { return "E-Mail-Verifizierung schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1834500441 = messageFormatterFn((function(  ) {
  return function(d) { return "Eingabe des Sicherheitscodes schließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a785385521 = messageFormatterFn((function(  ) {
  return function(d) { return "Buchung als Gast abschließen oder anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b991747247 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich bin Neukunde"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1096750352 = messageFormatterFn((function(  ) {
  return function(d) { return "Du kannst auch nach dem Buchungsabschluss noch ein Konto erstellen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1113379439 = messageFormatterFn((function(  ) {
  return function(d) { return "Buchung als Gast abschließen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1492919581 = messageFormatterFn((function(  ) {
  return function(d) { return "Ich bin bereits Kunde"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b720753459 = messageFormatterFn((function(  ) {
  return function(d) { return "Melde dich an, um Punkte für deine Buchung zu sammeln und einzulösen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1937385020 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden und buchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2125233003 = messageFormatterFn((function(  ) {
  return function(d) { return "Oder weiter mit"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1458437637 = messageFormatterFn((function(  ) {
  return function(d) { return "Willkommen zurück!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b956241996 = messageFormatterFn((function(  ) {
  return function(d) { return "Anmelden oder Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1907945857 = messageFormatterFn((function(  ) {
  return function(d) { return "Weiter"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a521528867 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben dir einen Link an " + d["0"] + " gesendet, mit dem du dein Passwort zurücksetzen kannst. Es kann einige Minuten dauern, bis du die E-Mail erhältst. Sieh in deinem Spam-Ordner nach, falls du die E-Mail nicht in deinem Posteingang findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1179318278 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort zurücksetzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1236840094 = messageFormatterFn((function(  ) {
  return function(d) { return "Dein Passwort muss aus mindestens 8 Zeichen bestehen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a8113256 = messageFormatterFn((function(  ) {
  return function(d) { return "Mit verbundenem Konto fortfahren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1304252994 = messageFormatterFn((function(  ) {
  return function(d) { return "oder Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1135533704 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast Post!"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1521710001 = messageFormatterFn((function(  ) {
  return function(d) { return "Wir haben einen Bestätigungslink an " + d["0"] + " gesendet, mit dem du ein Passwort für dein Konto festlegen kannst. Es kann einige Minuten dauern, bis du die E-Mail erhältst. Sieh in deinem Spam-Ordner nach, falls du die E-Mail nicht in deinem Posteingang findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1618423763 = messageFormatterFn((function(  ) {
  return function(d) { return "Passwort festlegen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a69966249 = messageFormatterFn((function(  ) {
  return function(d) { return "Bearbeiten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1378807147 = messageFormatterFn((function(  ) {
  return function(d) { return "Du hast anscheinend schon einmal bei uns gebucht. Aus Sicherheitsgründen muss deine E-Mail-Adresse bestätigt werden."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a2002626231 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwende den Bestätigungslink, den wir an " + d["0"] + " gesendet haben, um die Erstellung deines Kontos abzuschließen. Es kann einige Minuten dauern, bis du die E-Mail erhältst. Sieh in deinem Spam-Ordner nach, falls du die E-Mail nicht in deinem Posteingang findest."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1164393561 = messageFormatterFn((function(  ) {
  return function(d) { return "Meine Reiseinfos"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1358060492 = messageFormatterFn((function(  ) {
  return function(d) { return "Mein Konto"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1936620430 = messageFormatterFn((function(  ) {
  return function(d) { return "Deine persönlichen Daten und Einstellungen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1268308728 = messageFormatterFn((function(  ) {
  return function(d) { return "TSA-Informationen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b401275492 = messageFormatterFn((function(  ) {
  return function(d) { return "Known-Traveler-Nummer oder Redress-Nummer hinzufügen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1141896726 = messageFormatterFn((function(  ) {
  return function(d) { return "Persönliche Daten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1988930758 = messageFormatterFn((function(  ) {
  return function(d) { return "Grundlegende Infos und Kontaktdaten"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a621304401 = messageFormatterFn((function(  ) {
  return function(d) { return "Flugpräferenzen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a989063605 = messageFormatterFn((function(  ) {
  return function(d) { return "Einstellungen anpassen, um dein Erlebnis zu personalisieren"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1435598880 = messageFormatterFn((function(  ) {
  return function(d) { return "Bonusprogramme"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2030085948 = messageFormatterFn((function(  ) {
  return function(d) { return "Vielfliegerprogramme und andere Mitgliedschaften"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1831990162 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisepass"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1597790794 = messageFormatterFn((function(  ) {
  return function(d) { return "Reisepass speichern, um schneller buchen zu können"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1995917451 = messageFormatterFn((function(  ) {
  return function(d) { return "Geräte"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b715008145 = messageFormatterFn((function(  ) {
  return function(d) { return "Verwalte deiner Geräte, auf denen du angemeldet bist"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1185247095 = messageFormatterFn((function(  ) {
  return function(d) { return "In deinem Konto anmelden"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b751751110 = messageFormatterFn((function(  ) {
  return function(d) { return "Konto erstellen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1856747463 = messageFormatterFn((function(  ) {
  return function(d) { return "Leider ist bei uns etwas schiefgegangen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b174413006 = messageFormatterFn((function(  ) {
  return function(d) { return "Anscheinend bist du offline. Prüfe deine Internetverbindung und versuche es erneut."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1961260564 = messageFormatterFn((function(  ) {
  return function(d) { return "Erneut versuchen"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.a1004602461 = messageFormatterFn((function(  ) {
  return function(d) { return "Ladevorgang läuft ..."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1923860222 = messageFormatterFn((function(  ) {
  return function(d) { return "1 Nacht"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1640794870 = messageFormatterFn((function(  ) {
  return function(d) { return d["0"] + " Nächte"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1985457674 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig, 1 Nacht ausgewählt. Änderungen speichern und Kalender schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b771542402 = messageFormatterFn((function(  ) {
  return function(d) { return "Fertig, " + d["0"] + " Nächte ausgewählt. Änderungen speichern und Kalender schließen."; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2053848965 = messageFormatterFn((function(  ) {
  return function(d) { return "Datum"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1568616924 = messageFormatterFn((function(  ) {
  return function(d) { return "Es gibt " + d["0"] + " Ergebnisse"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b2022109028 = messageFormatterFn((function(  ) {
  return function(d) { return "Es gibt 1 Ergebnis"; }
})(), Globalize("de-DE").pluralGenerator({}));
Globalize.b1660126312 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy-MM-dd","timeSeparator":":"});
Globalize.a1520294616 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd/MM/yyyy","timeSeparator":":"});
Globalize.b535978709 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"d/M/yyyy","timeSeparator":":"});
Globalize.b1658432667 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/M/d","timeSeparator":":"});
Globalize.a1574435640 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd.MM.yyyy","timeSeparator":":"});
Globalize.b2082275539 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"d.M.yyyy","timeSeparator":":"});
Globalize.b922809640 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy/MM/dd","timeSeparator":":"});
Globalize.a1628576664 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"dd-MM-yyyy","timeSeparator":":"});
Globalize.b2136896360 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"MM/dd/yyyy","timeSeparator":":"});
Globalize.b777550101 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"M/d/yyyy","timeSeparator":":"});
Globalize.a856015672 = dateToPartsFormatterFn({"2":Globalize("de-DE").numberFormatter({"raw":"00"}),"4":Globalize("de-DE").numberFormatter({"raw":"0000"})}, {"pattern":"yyyy.MM.dd","timeSeparator":":"});
Globalize.b468003385 = dateToPartsFormatterFn({}, {"pattern":"EEEEE","timeSeparator":":","days":{"E":{"5":{"sun":"S","mon":"M","tue":"D","wed":"M","thu":"D","fri":"F","sat":"S"}}}});
Globalize.a400514264 = dateToPartsFormatterFn({}, {"pattern":"EEEE","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}}});
Globalize.b852731176 = dateToPartsFormatterFn({}, {"pattern":"MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1445632264 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d","timeSeparator":":"});
Globalize.b1721561013 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"}),"2":Globalize("de-DE").numberFormatter({"raw":"00"})}, {"pattern":"M/d/yy","timeSeparator":":"});
Globalize.a491159190 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1973295437 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1014404706 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1695230078 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"MMMM y","timeSeparator":":","months":{"M":{"4":{"1":"Januar","2":"Februar","3":"März","4":"April","5":"Mai","6":"Juni","7":"Juli","8":"August","9":"September","10":"Oktober","11":"November","12":"Dezember"}}}});
Globalize.a1695915271 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"d. MMM y","timeSeparator":":","months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.a1218141142 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"EEEE, d. MMM","timeSeparator":":","days":{"E":{"4":{"sun":"Sonntag","mon":"Montag","tue":"Dienstag","wed":"Mittwoch","thu":"Donnerstag","fri":"Freitag","sat":"Samstag"}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1980683605 = dateToPartsFormatterFn({"1":Globalize("de-DE").numberFormatter({"raw":"0"})}, {"pattern":"E, d. MMM","timeSeparator":":","days":{"E":{"1":{"sun":"So.","mon":"Mo.","tue":"Di.","wed":"Mi.","thu":"Do.","fri":"Fr.","sat":"Sa."}}},"months":{"M":{"3":{"1":"Jan.","2":"Feb.","3":"März","4":"Apr.","5":"Mai","6":"Juni","7":"Juli","8":"Aug.","9":"Sept.","10":"Okt.","11":"Nov.","12":"Dez."}}}});
Globalize.b1281412561 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy-MM-dd"}));
Globalize.a1899008367 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd/MM/yyyy"}));
Globalize.a1278938498 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d/M/yyyy"}));
Globalize.a156484540 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy/M/d"}));
Globalize.a1953149391 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd.MM.yyyy"}));
Globalize.b267358332 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d.M.yyyy"}));
Globalize.b544095889 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy/MM/dd"}));
Globalize.a2007290415 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"dd-MM-yyyy"}));
Globalize.b1758182609 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"MM/dd/yyyy"}));
Globalize.a1037367106 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"M/d/yyyy"}));
Globalize.a1234729423 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"yyyy.MM.dd"}));
Globalize.b619176752 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"EEEEE"}));
Globalize.b435646289 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"EEEE"}));
Globalize.b1688891729 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"MMMM"}));
Globalize.a2028915857 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"d"}));
Globalize.b2112968094 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"raw":"M/d/yy"}));
Globalize.a919017759 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMd"}));
Globalize.b1594581686 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMMd"}));
Globalize.b130370901 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMMd"}));
Globalize.a2073943829 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMM"}));
Globalize.a2074629022 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"yMMMd"}));
Globalize.a600410591 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMEEEEd"}));
Globalize.b1601969854 = dateFormatterFn(Globalize("de-DE").dateToPartsFormatter({"skeleton":"MMMEd"}));
Globalize.a332649182 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy-MM-dd","digitsRe":/\d/});
Globalize.b781897186 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd/MM/yyyy","digitsRe":/\d/});
Globalize.a489557489 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d/M/yyyy","digitsRe":/\d/});
Globalize.b632896469 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/M/d","digitsRe":/\d/});
Globalize.b727756162 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd.MM.yyyy","digitsRe":/\d/});
Globalize.b1056739341 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d.M.yyyy","digitsRe":/\d/});
Globalize.a1069965854 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy/MM/dd","digitsRe":/\d/});
Globalize.b673615138 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"dd-MM-yyyy","digitsRe":/\d/});
Globalize.b144120866 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MM/dd/yyyy","digitsRe":/\d/});
Globalize.a247986097 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yyyy","digitsRe":/\d/});
Globalize.b1446176130 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"yyyy.MM.dd","digitsRe":/\d/});
Globalize.a1186958017 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEEE","digitsRe":/\d/,"gregorian/days/format/narrow":[["sun",/^S/],["mon",/^M/],["tue",/^D/],["wed",/^M/],["thu",/^D/],["fri",/^F/],["sat",/^S/]]});
Globalize.b1347215202 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]]});
Globalize.a1694506654 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a471128834 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d","digitsRe":/\d/});
Globalize.b1957365103 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"M/d/yy","digitsRe":/\d/});
Globalize.b2076957040 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a19480057 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b1634064420 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b606961724 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"MMMM y","digitsRe":/\d/,"gregorian/months/format/wide":[["9",/^September/],["11",/^November/],["12",/^Dezember/],["2",/^Februar/],["10",/^Oktober/],["1",/^Januar/],["8",/^August/],["4",/^April/],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b606276531 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"d. MMM y","digitsRe":/\d/,"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.b1340049712 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"EEEE, d. MMM","digitsRe":/\d/,"gregorian/days/format/wide":[["thu",/^Donnerstag/],["tue",/^Dienstag/],["wed",/^Mittwoch/],["sun",/^Sonntag/],["fri",/^Freitag/],["sat",/^Samstag/],["mon",/^Montag/]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
Globalize.a12091889 = dateParserFn(Globalize("de-DE").numberParser({"raw":"0"}), {"preferredTimeData":"H"}, {"pattern":"E, d. MMM","digitsRe":/\d/,"gregorian/days/format/abbreviated":[["sun",/^So\./],["mon",/^Mo\./],["tue",/^Di\./],["wed",/^Mi\./],["thu",/^Do\./],["fri",/^Fr\./],["sat",/^Sa\./]],"gregorian/months/format/abbreviated":[["9",/^Sept\./],["1",/^Jan\./],["2",/^Feb\./],["4",/^Apr\./],["8",/^Aug\./],["10",/^Okt\./],["11",/^Nov\./],["12",/^Dez\./],["3",/^März/],["6",/^Juni/],["7",/^Juli/],["5",/^Mai/]]});
module.exports = Globalize;
